import {AxiosResponse} from "axios";
import ApiResponse from "../Models/ApiResponse";
import api from "../Interceptors/Interceptor";

export interface IConversationMessageRatingModel {
	rating: number | undefined
}

export class ConversationMessageService {

	public async postMessage(uuid: string, message: IConversationMessageRatingModel): Promise<AxiosResponse<ApiResponse<any>>> {
		return await api.post(`v1/${this.modelUrl()}/${uuid}/rate`, message);
	}

	protected modelUrl(): string {
		return "conversation-message";
	}

}